
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {baseUrl, limit} from "../../../../comman/config";
import { can } from "../../../../comman/permissions";
import { useNavigate, Link } from 'react-router-dom';
import ColumnFilterRow from "../../../../components/Filter/ColumnFilterRow";
import { isFilterActive, matchFilterText, patchFilter } from "../../../../components/Filter/columnFilter";
import Loader from "../../../../components/Loader";
// import Pagination from "react-js-pagination";

// The table's columns, in order, with the type that decides which operators its filter offers.
// text(item) is the cell's own displayed value, so filtering and reading agree -- Trolly Type
// filters on "કેટેગરી (Category)" exactly as the cell prints it.
//
// Photo holds an image and Action holds buttons; neither is filterable, but both still need a
// cell in the filter row or every column below it shifts.
const COLS = [
    { key: 'photo',                label: 'Photo',                     filterable: false },
    { key: 'name',                 label: 'Trolly Name',               type: 'text',   text: (i) => i.name },
    { key: 'trolly_type',          label: 'Trolly Category',               type: 'text',   text: (i) => (i.type ? `${i.type.name} (${i.type.eng_name})` : '-') },
    { key: 'empty_weight',         label: 'Trolly Weight (kgs.)',                       text: (i) => i.empty_weight },
    { key: 'length',               label: 'Length (cms.)',                             text: (i) => i.length },
    { key: 'width',                label: 'Width (cms.)',                              text: (i) => i.width },
    { key: 'height',               label: 'Height (cms.)',                             text: (i) => i.height },
    { key: 'length_between_wheels',label: 'Length Bet. Wheels (cms.)',                 text: (i) => i.length_between_wheels },
    { key: 'width_between_wheels', label: 'Width Bet. Wheels (cms.)',                 text: (i) => i.width_between_wheels },
    { key: 'status',               label: 'Status',                    type: 'status', text: (i) => (Number(i.status) === 1 ? 'Active' : 'Inactive') },
    { key: 'action',               label: 'Action',                    filterable: false },
];

function List() {

    const [trollyMasterList, setTrollyMasterList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    // Inline per-column filters, as the Raw Report has them, in place of the single search box
    // that used to sit above the table.
    const [filters, setFilters] = useState({});

    // role 0 = superadmin, 1 = admin. Both may enable and disable; only the superadmin may delete.
    const role = String(localStorage.getItem('userRole'));
    // Which buttons this user gets is Role Master's call now, not a role number's -- see
    // comman/permissions.js. `role` is still read because it is what the delete and enable
    // endpoints are told to check against.
    const canDisable = can('disable');
    const canActivate = can('active');
    const canDelete = can('delete');

    const navigate = useNavigate();

    useEffect(() => {
        getTrollyMaster();
        
    }, []);

    // Every active column filter must pass, matched against the same text the cell shows.
    const activeCols = COLS.filter((c) => c.filterable !== false && isFilterActive(filters[c.key]));
    const visibleRows = trollyMasterList.filter((item) => activeCols.every((c) => matchFilterText(c.text(item), filters[c.key])));
    const onFilterChange = (key, patch) => setFilters((prev) => patchFilter(prev, key, patch));
    const clearFilters = () => setFilters({});



    const getTrollyMaster = async () => {
        // try/finally, because the spinner this sets is now on screen: a request that fails --
        // which on a slow connection is the case it exists for -- used to skip the line that
        // turns it off and leave it spinning over an empty table for good.
        setPopupOpen(true);
        try {
            const response = await axios.get(`${baseUrl}/trolly_master/list?page=${page}&limit=${limit}`);
            setTrollyMasterList(response.data.data);
            setTotalItem(response.data.totalItem);
        } catch (error) {
            console.log(error);
            alert('Could not load the list. Check the connection and try again.');
        } finally {
            setPopupOpen(false);
        }
    }


    // const deleteVessel = async (id) => {
    //     const shouldDelete = window.confirm("Are you sure you want to disable this ingredient?");
    //     if (shouldDelete) {
    //         try {
    //             await axios.delete(`${baseUrl}/ingredients/delete/${id}`);
    //             window.location.reload();
    //         } catch (error) {
    //             console.log(error);
    //         }
    //     }
    // };


    // /trolly_master, which is where the router is mounted -- these three asked /trolly, which is
    // not a mount at all, so every one of them was a 404. The list read from /trolly_master/list
    // and worked, which is why the screen looked fine right up until a button was pressed.
    const disableTrolly = async (id) => {
        if (!window.confirm("Are you sure you want to disable this trolly?")) return;
        try {
            await axios.delete(`${baseUrl}/trolly_master/delete/${id}`, { data: { role } });
            window.location.reload();
        } catch (error) {
            alert(error?.response?.data?.msg ?? 'Could not disable the trolly.');
        }
    };

    const enableTrolly = async (id) => {
        if (!window.confirm("Enable this trolly?")) return;
        try {
            await axios.post(`${baseUrl}/trolly_master/enable/${id}`, { role });
            window.location.reload();
        } catch (error) {
            alert(error?.response?.data?.msg ?? 'Could not enable the trolly.');
        }
    };

    // Delete removes the row, unlike Disable which is recoverable, so its confirmation says so.
    const destroyTrolly = async (id) => {
        if (!window.confirm("Permanently DELETE this trolly? Disable is reversible; this is not.")) return;
        try {
            await axios.delete(`${baseUrl}/trolly_master/destroy/${id}`, { data: { role } });
            window.location.reload();
        } catch (error) {
            alert(error?.response?.data?.msg ?? 'Could not delete the trolly.');
        }
    };

    const editTrollyMaster = async (id) => {
        navigate(`/trolly_master/edit/${btoa(id)}`, { state: trollyMasterList.filter(item => item.id == id) });
    }

   


    return (
        <div className="p-4">
            {popupOpen && <Loader />}
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Trolly Master</h1>
                <div>
                    <Link to="/trolly_master/add">
                        <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Trolly</button>
                    </Link>
                </div>
            </div>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                {/* The search box that used to sit here is gone: the filters are in the header
                    row now, one per column, so a search is made where the column is read. */}
                <div className="flex items-center justify-end pb-4">
                    <button
                        onClick={clearFilters}
                        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
                    >
                        Clear
                    </button>
                </div>
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            {COLS.map((c) => <th key={c.key} scope="col" className="px-6 py-3">{c.label}</th>)}
                        </tr>
                        <ColumnFilterRow
                            cols={COLS}
                            filters={filters}
                            onChange={onFilterChange}
                            thClassName="px-2 py-1 bg-gray-50 align-top"
                        />
                    </thead>
                    <tbody>
                    {visibleRows.map((item) => (
                        <tr key={item.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                            <td className="px-6 py-4">{item.photo}</td>
                            <td className="px-6 py-4">{item.name}</td>
                            <td className="px-6 py-4">{item.type ? `${item.type.name} (${item.type.eng_name})` : "-"}</td>
                            <td className="px-6 py-4">{item.empty_weight}</td>
                            <td className="px-6 py-4">{item.length}</td>
                            <td className="px-6 py-4">{item.width}</td>
                            <td className="px-6 py-4">{item.height}</td>
                            <td className="px-6 py-4">{item.length_between_wheels}</td>
                            <td className="px-6 py-4">{item.width_between_wheels}</td>
                            <td className="px-6 py-4">{Number(item.status) === 1 ? 'Active' : 'Inactive'}</td>
                            <td className="px-6 py-4">
                            <div className="flex gap-2">
                                <button
                                    type="button"
                                    onClick={() => editTrollyMaster(item.id)}
                                    className="px-3 py-1 text-sm bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">
                                    Edit
                                </button>
                                {item.status == 1 && canDisable && <button
                                    type="button"
                                    onClick={() => disableTrolly(item.id)}
                                    className="px-3 py-1 text-sm bg-red-500 text-white rounded-md hover:bg-red-600 focus:outline-none focus:ring focus:ring-red-200">
                                    Disable
                                </button>}
                                {item.status == 0 && canActivate && <button
                                    type="button"
                                    onClick={() => enableTrolly(item.id)}
                                    className="px-3 py-1 text-sm bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring focus:ring-green-200">
                                    Enable
                                </button>}
                                {canDelete && <button
                                    type="button"
                                    onClick={() => destroyTrolly(item.id)}
                                    className="px-3 py-1 text-sm bg-red-700 text-white rounded-md hover:bg-red-800 focus:outline-none focus:ring focus:ring-red-300">
                                    Delete
                                </button>}
                            </div>
                            </td>
                        </tr>))}
           
                    </tbody>
                </table>
            </div>
        </div>
  );
}

export default List;